// removed by extract-text-webpack-plugin
module.exports = {"owner":"owner___2k854","new":"new___35nFZ","warning":"warning___3pTwF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Userrequest/RequestTitle.module.scss
// module id = 2305
// module chunks = 0